import { modalName } from '@va/constants';
import { openModal } from '@va/dashboard/actions/ui';
import { getEmail, hasData as hasDataSelector } from '@va/dashboard/selectors/core';
import { ResetDataCardComponent } from '@va/dashboard/ui/pages';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ResetDataModalWix } from './ResetDataModalWix';

export const ResetDataCardWix = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const [isResetDataModalOpen, setIsResetDataModalOpen] = useState(false);

  const isContributor = useSelector(contributorRole);
  const hasData = useSelector(hasDataSelector);
  const email = useSelector(getEmail);

  const onClick = () => {
    if (!email) return dispatch(openModal(modalName.accountSettingsRequired));
    setIsResetDataModalOpen(true);
  };

  const tooltipText = useMemo(() => {
    if (isContributor) return translate('tooltips.contributorRole');
    if (!hasData) return translate('card.deleteData.noDataTooltip');
    return undefined;
  }, [hasData, isContributor, translate]);

  return (
    <>
      <ResetDataModalWix
        onClose={() => {
          setIsResetDataModalOpen(false);
        }}
        isModalOpen={isResetDataModalOpen}
      />
      <ResetDataCardComponent tooltip={tooltipText} onClick={onClick} disabled={false} />
    </>
  );
};
